import { UserStatus, USER_STATUS } from 'constants/status';

export const userStatus = (status?: string): string => {
  switch (status) {
    case USER_STATUS.active:
      return UserStatus.active;
    case USER_STATUS.accepted:
      return UserStatus.accepted;
    case USER_STATUS.draft:
      return UserStatus.draft;
    case USER_STATUS.invited:
      return UserStatus.invited;
    case USER_STATUS.idvApproved:
      return UserStatus.idvApproved;
    case USER_STATUS.idvDeclined:
      return UserStatus.idvDeclined;
    case USER_STATUS.idvInReview:
      return UserStatus.idvInReview;
    case USER_STATUS.idvNotStarted:
      return UserStatus.idvNotStarted;
    case USER_STATUS.idvSubmitted:
      return UserStatus.idvSubmitted;
    case USER_STATUS.kycApproved:
      return UserStatus.kycApproved;
    case USER_STATUS.kycDeclined:
      return UserStatus.kycDeclined;
    case USER_STATUS.kycInReview:
      return UserStatus.kycInReview;
    case USER_STATUS.kycNotStarted:
      return UserStatus.kycNotStarted;
    case USER_STATUS.kycSubmitted:
      return UserStatus.kycSubmitted;
    case USER_STATUS.accountProcessing:
      return UserStatus.accountProcessing;
    case USER_STATUS.accountCreationFailed:
      return UserStatus.accountCreationFailed;

    default:
      return status ?? '';
  }
};
